import React, { useContext, useEffect, useState } from 'react';
import CrewLogs from './components/forms/CrewLogs';
import EquipmentLogs from './components/forms/EquipmentLogs';
import GeneratorLogs from './components/forms/GeneratorLogs';
import GroundTransportLogs from './components/forms/GroundTransportLogs';
import PropertyMaterialLogs from './components/forms/PropertyMaterialLogs';
import { Col, Card, Tab, Nav, Dropdown } from "react-bootstrap";

function SiteLogs() {
	const [vendorIdOptions, setVendorIdOptions] = useState([{ value: "-1", label: "Fetching Please wait..." }]);

    const tabData = [
		{
			name: "Propery & Material",
			content: <PropertyMaterialLogs vendorIdOptions={vendorIdOptions}></PropertyMaterialLogs>,
		},
		{
			name: "Equipment",
			content: <EquipmentLogs vendorIdOptions={vendorIdOptions}></EquipmentLogs>,
		},
		{
			name: "Generator",
			content: <GeneratorLogs vendorIdOptions={vendorIdOptions}></GeneratorLogs>,
		},

		{
			name: "Ground Transportation",
			content: <GroundTransportLogs vendorIdOptions={vendorIdOptions}></GroundTransportLogs>,
		},
		{
			name: "Crew Log",
			content: <CrewLogs vendorIdOptions={vendorIdOptions}></CrewLogs>,
		}
	];

    return (
        <div className="col-xl-12">
            <div className="row">
                
        <div className="col-lg-12 col-md-12 col-sm-12">
                <Card>
                    <Card.Header className='border-0 pb-0' >
                        <Card.Title>Add Logs</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {/* <!-- Nav tabs --> */}
                        <div className="default-tab">
                            <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                                <Nav as="ul" className="nav-tabs">
                                    {tabData.map((data, i) => (
                                        <Nav.Item as="li" key={i}>
                                            <Nav.Link eventKey={data.name.toLowerCase()}>
                                                {data.name}
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                                <Tab.Content className="pt-4">
                                    {tabData.map((data, i) => (
                                        <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                                            <p>{data.content}</p>
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </Card.Body>
                </Card>
                
        </div>
            </div>
        </div>
    )
}

export default SiteLogs